import React from "react";
import { RecycleOverview } from "./components/overview/recycle-overview";

// Mock data for testing
const mockMetrics = [
  {
    label: "Total Items Recycled",
    value: "1,234",
    trend: "+12.3%",
    description: "Last 30 days"
  },
  {
    label: "Materials Recovered",
    value: "856 kg",
    trend: "+8.7%",
    description: "Last 30 days"
  },
  {
    label: "Carbon Offset",
    value: "2.4t",
    trend: "+15.2%",
    description: "Last 30 days"
  },
  {
    label: "Active Programs",
    value: "8",
    trend: "+2",
    description: "Since last month"
  }
];

const mockRecentRecycles = [
  {
    id: "REC-001",
    customer: {
      name: "John Doe",
      email: "john@example.com"
    },
    itemType: "Electronics",
    status: "processing",
    location: "San Francisco, CA",
    requestDate: "2024-03-15"
  },
  {
    id: "REC-002",
    customer: {
      name: "Jane Smith",
      email: "jane@example.com"
    },
    itemType: "Packaging",
    status: "completed",
    location: "New York, NY",
    requestDate: "2024-03-14"
  }
];

export function RecyclePage() {
  return (
    <div className="p-6">
      <RecycleOverview />
    </div>
  );
}
